var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 40,
    viewBox: "0 0 19 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4.70533C12.1189 4.70533 14.2493 6.816 14.2493 9.41067C14.2493 12.0053 12.1189 14.116 9.5 14.116C6.88107 14.116 4.75067 12.0053 4.75067 9.41067C4.75067 6.81733 6.88107 4.70533 9.5 4.70533ZM9.5 0C4.25407 0 0 4.21333 0 9.412C0 14.6093 4.25272 18.824 9.5 18.824C14.7459 18.824 19 14.6107 19 9.412C19 4.21333 14.7459 0 9.5 0Z",
    fill: "#FF5349"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21.1758H0V25.8811H19V21.1758Z",
    fill: "#FF5349"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 35.2939H0V39.9993H19V35.2939Z",
    fill: "#FF5349"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 28.2344H0V32.9397H19V28.2344Z",
    fill: "#FF5349"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.19469033c519d9a0f12e8932a5cde189.svg";
export { ForwardRef as ReactComponent };